export default __webpack_public_path__ + "2ef6d500c3155fdcac1a0dab6e7f0801.png";